export const isDevelopment = import.meta.env.MODE === "development";
export const isStaging = import.meta.env.VITE_ENV === "staging";
export const isProduction = import.meta.env.MODE === "production";

// App URLs
export const APP_URL = isDevelopment
  ? "http://localhost:3000"
  : isStaging
    ? "https://dev.zapify.pro"
    : "https://ai.zapify.pro";

// Auth URLs
export const AUTH_URL = isDevelopment
  ? "http://localhost:4000"
  : isStaging
    ? "https://dev-api.zapify.pro"
    : "https://api.zapify.pro";

// Instagram OAuth config
export const ENABLE_FORCE_REAUTH = true;

// Environment helpers
export const ENV = {
  isDevelopment,
  isStaging,
  isProduction,
  current: import.meta.env.MODE || "development",
};
